export const buildUpdateClientGroupPortfolioInput = ({
  clientGroupId,
  financialProductId,
  tradingProcess,
}: {
  clientGroupId: string;
  financialProductId: string;
  // Optional: the backend `UpdateClientGroupPortfolioInput.tradingProcess` is
  // nullable/optional. Omit it when not selected rather than sending undefined.
  tradingProcess?: string;
}) => ({
  clientGroupId,
  financialProductId,
  ...(tradingProcess ? { tradingProcess } : {}),
});

export const buildDetachClientGroupPortfolioInput = (
  clientGroupId: string,
) => ({
  clientGroupId,
  financialProductId: null,
});
